export default __webpack_public_path__ + "static/media/hht2_ep_12.64874954.png";